// removed by extract-text-webpack-plugin
module.exports = {"headline":"StoryContent__headline--2-2FM","featured":"StoryContent__featured--22hK-","bounce":"StoryContent__bounce--2KCYB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoryContent/StoryContent.css
// module id = ./src/components/Library/StoryContent/StoryContent.css
// module chunks = 1